export default "__VITE_ASSET__Dg79isTt__"